import { Routes, Route } from "react-router-dom";
import { MarketingLayout, HomePage } from "@/MarketingSite";
import SlaughterhouseSoftwarePage from "@/pages/SlaughterhouseSoftwarePage";
import LivestockManagementPage from "@/pages/LivestockManagementPage";
import ProteinSupplyChainPage from "@/pages/ProteinSupplyChainPage";
import Snap404Page from "@/pages/Snap404Page";

export default function App() {
  return (
    <Routes>
      <Route element={<MarketingLayout />}>
        <Route index element={<HomePage />} />
        <Route path="slaughterhouse-software" element={<SlaughterhouseSoftwarePage />} />
        <Route path="livestock-management" element={<LivestockManagementPage />} />
        <Route path="protein-supply-chain" element={<ProteinSupplyChainPage />} />
        <Route path="404.html" element={<Snap404Page />} />
      </Route>
    </Routes>
  );
}
